import React from 'react'
import Logo from './logo'
import {
  AppBar,
  Toolbar,
  Typography,
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  Icon,
} from '@material-ui/core'
import { Router } from 'routes'
import Link from 'next/link'
import { useCurrentUser } from 'utils/context/UserContext'

const Component = ({ onLogout }) => {
  const [menuAnchor, setMenuAnchor] = React.useState(null)
  const closeMenu = () => setMenuAnchor(null)
  const openMenu = e => setMenuAnchor(e.currentTarget)
  const { currentUser } = useCurrentUser()

  return (
    <div style={{ position: 'relative' }}>
      <AppBar
        position="static"
        style={{
          background: 'linear-gradient(to bottom right, #FF2942 25%, #0C44ED)',
        }}
      >
        <Toolbar>
          <Typography
            variant="h6"
            color="inherit"
            style={{
              flexGrow: 1,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Logo style={{ lineHeight: 10 }} height="2em" width="6em" />
          </Typography>
          <div>
            <IconButton
              aria-owns={menuAnchor ? 'accout-menu' : undefined}
              aria-haspopup="true"
              onClick={openMenu}
            >
              <Avatar
                src={currentUser?.photoURL}
                style={{ backgroundColor: '#B0B0B0' }}
              >
                {!currentUser?.photoURL && <Icon>person</Icon>}
              </Avatar>
            </IconButton>
            <Menu
              anchorEl={menuAnchor}
              id="account-menu"
              open={!!menuAnchor}
              onClose={closeMenu}
            >
              <MenuItem onClick={() => Router.pushRoute('root')}>
                アプリへ
              </MenuItem>
              <MenuItem onClick={() => Router.pushRoute('adminItems')}>
                アイテム一覧
              </MenuItem>
              <MenuItem onClick={() => Router.pushRoute('adminArtists')}>
                アーティスト一覧
              </MenuItem>
              <Link passHref href="/logout">
                <MenuItem component="a">ログアウト</MenuItem>
              </Link>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  )
}

export default Component
